var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponBackgroundRtl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 118,
    viewBox: "0 0 343 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_795)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.491 5.8125C250.568 2.21571 254.405 0 258.558 0H331C337.627 0 343 5.37259 343 12V106C343 112.627 337.627 118 331 118H258.342C254.233 118 250.437 115.808 248.383 112.25C243.956 104.583 232.89 104.583 228.464 112.25C226.41 115.808 222.613 118 218.505 118H12C5.37258 118 0 112.627 0 106V12C0 5.37258 5.37259 0 12 0H218.288C222.442 0 226.279 2.21571 228.356 5.8125C232.83 13.5625 244.016 13.5625 248.491 5.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5 12V106",
    stroke: "#D9DCE1",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 118,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponBackgroundRtl);
export default __webpack_public_path__ + "static/media/coupon-background-rtl.710b4f5ea113e3a8d06292f7f17b8dbe.svg";
export { ForwardRef as ReactComponent };